<template>
    <div v-show="show" :class="wrapperCssClass">
        <slot>
            <label :for="id" v-if="showValidation || label">
                <span v-if="label" v-text="label"></span>
                <span class="validation" :class="validationDisplayClass" v-show="errors.has(name)" v-if="showValidation">
                    <span
                        v-for="(message, index) in validation"
                        v-show="errors.display(name, index)"
                        v-text="message"
                    ></span>
                </span>
            </label>
        </slot>
        <input
            :type="inputType"
            :name="name"
            :id="id"
            :maxlength="maxlength"
            :placeholder="placeholder"
            :autocomplete="autocomplete"
            :class="invalidClass"
            :style="cssStyle"
            :disabled="disabled"
            :value="value"
            @input="update($event.target.value)"
            v-focus="focus"
        >
    </div>
</template>
<script>
    import TextInput from '../../../mixins/Form/TextInput.vue';
    export default {
        mixins: [TextInput]
    }
</script>